import React, { useState } from "react";
import Button from "../../ui/Button";

export default function ControlFilters({
  search,
  onSearchChange,
  status,
  onStatusChange,
  statusOptions,
  owner,
  onOwnerChange,
  ownerOptions,
  category,
  onCategoryChange,
  categoryOptions,
  categoryError,
  catalog,
  onCatalogChange,
  sort,
  onSortChange,
  asOf,
  onAsOfChange,
  showSort = true,
}) {
  const resolvedStatusOptions =
    Array.isArray(statusOptions) && statusOptions.length > 0
      ? statusOptions
      : ["Active", "Draft", "Open", "In Progress", "Closed", "Archived"];

  // Progressive disclosure keeps primary filters visible and lowers cognitive load.
  const [showAdvanced, setShowAdvanced] = useState(false);

  return (
    <div style={{ display: "grid", gap: 12 }}>
      <div
        style={{
          display: "grid",
          gap: 12,
          gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
          alignItems: "center",
        }}
      >
        <input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search..."
          style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db" }}
        />
        <select
          value={status}
          onChange={(e) => onStatusChange(e.target.value)}
          style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db" }}
        >
          <option value="">Status</option>
          {resolvedStatusOptions.map((s) => (
            <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
      {typeof onAsOfChange === "function" && (
        <input
          type="date"
          value={asOf || ""}
          onChange={(e) => onAsOfChange(e.target.value)}
          aria-label="As at date"
          style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db" }}
        />
      )}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            onClick={() => setShowAdvanced((prev) => !prev)}
            variant="secondary"
            style={{ padding: "10px 12px", borderRadius: 8, borderColor: "#d1d5db", background: "#fff" }}
          >
            {showAdvanced ? "Less filters" : "More filters"}
          </Button>
        </div>
      </div>

      {showAdvanced && (
        <div
          style={{
            display: "grid",
            gap: 12,
            gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
            alignItems: "center",
          }}
        >
          <select
            value={owner}
            onChange={(e) => onOwnerChange(e.target.value)}
            style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db" }}
          >
            <option value="">Owner</option>
            {(Array.isArray(ownerOptions) ? ownerOptions : []).map((opt) => (
              <option key={opt.value ?? opt} value={opt.value ?? opt}>
                {opt.label ?? opt}
              </option>
            ))}
          </select>
          {Array.isArray(categoryOptions) && categoryOptions.length > 0 ? (
            <select
              value={category}
              onChange={(e) => onCategoryChange(e.target.value)}
              style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db" }}
            >
              <option value="">Category</option>
              {categoryOptions.map((opt) => (
                <option key={opt.value ?? opt} value={opt.value ?? opt}>
                  {opt.label ?? opt}
                </option>
              ))}
            </select>
          ) : (
            <input
              value={category}
              onChange={(e) => onCategoryChange(e.target.value)}
              placeholder={categoryError || "Category"}
              style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db" }}
            />
          )}
          <input
            value={catalog}
            onChange={(e) => onCatalogChange(e.target.value)}
            placeholder="Catalog ID"
            style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db" }}
          />
          {showSort && typeof onSortChange === "function" && (
            <select
              value={sort}
              onChange={(e) => onSortChange(e.target.value)}
              style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #d1d5db" }}
            >
              <option value="">Sort</option>
              <option value="name">Name</option>
              <option value="status">Status</option>
              <option value="owner_id">Owner</option>
            </select>
          )}
        </div>
      )}
    </div>
  );
}
